import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import CheckboxListField from "../../../components/Fields/CheckboxListField";
import { FormConfig, SelectListOption } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import SpinnerOverlay from "../../../components/Spinner/SpinnerOverlay";
import Translate from "../../../components/Translate";
import { useNotifications } from "../../../contexts/notificationContext";
import ItemSearchResult from "../../../models/ItemSearchResult";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface Props extends PopupProps {
    selectedItems: ItemSearchResult[]
    onDelete: (itemRevisionIds: number[]) => void
}

interface IFormData {
    itemRevisionIds: number[]
}

const DeleteItemRevisionPopup: React.FC<Props> = ({ show, onHide, onDelete, selectedItems }) => {
    const [formData, setFormData] = useState<IFormData>({ itemRevisionIds: [] });
    const [showSpinner, setShowSpinner] = useState<boolean>(false);
    const { handleResult, handleException } = useNotifications();

    const [itemRevisionsToSelect, setItemRevisionToSelect] = useState<SelectListOption[]>()


    useEffect(() => {
        var options: SelectListOption[] = selectedItems.map(itemRevision => {
            return { value: itemRevision.itemRevisionId, label: itemRevision.itemNr + '-v' + itemRevision.revisionNumber };
        })
        setItemRevisionToSelect(options)
        formData.itemRevisionIds = selectedItems.map(option => { return option.itemRevisionId })
    }, [selectedItems])


    function submit() {
        if (formData) {
            setShowSpinner(true)
            DataService
                .post<DataResult<number[]>>(`api/v1/ItemRevisions/DeleteMultiple`, formData)
                .then(response => {
                    setShowSpinner(false)
                    handleResult(response)
                    if (response.data)
                        onDelete(response.data)

                    onHide()
                })
                .catch(e => handleException(e))
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'itemRevisionIds', label: 'Revision' },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData);

    return (
        <>
            <Popup show={show} onHide={onHide} size={'lg'} title={'Delete item'} >
                <Popup.Body>
                    <CheckboxListField {...getFieldProps('itemRevisionIds')} options={itemRevisionsToSelect} layout='vertical' />
                    <p><Translate>Are you sure you want to delete all selected itemrevisions?</Translate></p>
                </Popup.Body>
                <Popup.Footer>
                    <SaveButton {...getSubmitButtonProps()} text='Delete' variant='danger' />
                </Popup.Footer>
            </Popup>
            {showSpinner && (<SpinnerOverlay />)}
        </>

    );
}
export default DeleteItemRevisionPopup;
